"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _getComponentName = _interopRequireDefault(require("react-utils/getComponentName"));

var _utils = require("./utils");

var _refObject = _interopRequireDefault(require("../utils/propTypes/refObject"));

function _default(Component) {
  var ShareScrollElementComponent = (0, _react.forwardRef)(function (props, ref) {
    var scrollElementRef = props.scrollElementRef,
        rest = (0, _objectWithoutProperties2.default)(props, ["scrollElementRef"]);
    var defaultRef = (0, _react.useRef)(null);
    return _react.default.createElement(Component, Object.assign({}, rest, {
      scrollElementRef: scrollElementRef || defaultRef,
      ref: ref
    }));
  });
  var componentName = (0, _getComponentName.default)(Component);
  ShareScrollElementComponent.displayName = "ShareScrollElement(" + componentName + ")";
  ShareScrollElementComponent.propTypes = Object.assign({}, Component.propTypes, {
    scrollElementRef: _refObject.default
  });
  ShareScrollElementComponent.defaultProps = Component.defaultProps;
  (0, _utils.attachWrappedComponent)(ShareScrollElementComponent, Component);
  return ShareScrollElementComponent;
}

module.exports = exports.default;